import { render, staticRenderFns } from "./SPKBLunasDetail.vue?vue&type=template&id=1a72114c&"
import script from "./SPKBLunasDetail.vue?vue&type=script&lang=js&"
export * from "./SPKBLunasDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports